// /* ================================
//    PRODUCT IMAGE FILTERING (ALT TEXT BASED)
//    ================================ */

// document.addEventListener('DOMContentLoaded', () => {
//   document.addEventListener('variant:change', (event) => {
//     const variant = event.detail.variant;
//     if (!variant) return;

//     let section = document.querySelector('#shopify-section-main-product');
//     if (!section) {
//       section = event.target.closest('.product-grid');
//     }
//     if (!section) return;

//     const slides = section.querySelectorAll('.product-gallery__slide');
//     const variantText = variant.options.join(' ').toLowerCase();

//     slides.forEach(slide => {
//       const alt = slide.dataset.alt;
//       const alwaysShow = slide.dataset.alwaysShow === 'true';

//       // Rule 1: No alt text → always visible
//       if (alwaysShow || !alt) {
//         slide.classList.remove('hidden');
//         return;
//       }

//       // Rule 2 & 3: All alt parts must match variant options
//       const altParts = alt.split(' ').filter(Boolean);
//       const matches = altParts.every(part => variantText.includes(part));

//       slide.classList.toggle('hidden', !matches);
//     });
//   });
// });

// /* ================================
//    INITIAL LOAD SAFETY (OPTIONAL BUT RECOMMENDED)
//    ================================ */

// document.addEventListener('DOMContentLoaded', () => {
//   const picker = document.querySelector('variant-picker');
//   if (!picker || !picker.__variant) return;

//   document.dispatchEvent(
//     new CustomEvent('variant:change', {
//       detail: { variant: picker.__variant }
//     })
//   );
// });


// /* ================================
//    START: Essential Preorder app
//    (UNCHANGED)
//    ================================ */

// document.addEventListener("DOMContentLoaded", function () {
//   let retries = 0;

//   function tryFindElements() {
//     const inactive = document.querySelector(".essential-preorder-container-inactive");
//     if (inactive) return; // STOP

//     const button = document.querySelector(
//       '.essential-preorder-container-active button[type="submit"]'
//     );
//     if (button) {
//       button.setAttribute("data-essential-preorder-element", "button");

//       const text = button.querySelector('span');

//       if (text) {
//         text.classList.add('essential-preorder-initial-add-to-cart-text');
//       }

//       return; // STOP
//     }

//     retries++;
//     if (retries < 3) {
//       setTimeout(tryFindElements, 100);
//     }
//   }

//   function handleVariantChange() {
//     retries = 0;
//     tryFindElements();
//   }

//   // Run on initial load
//   tryFindElements();

//   // Trigger on URL change (variant param changes)
//   window.addEventListener("popstate", handleVariantChange);

//   // Patch pushState/replaceState to catch JS-driven URL changes
//   ["pushState", "replaceState"].forEach((type) => {
//     const orig = history[type];
//     history[type] = function () {
//       orig.apply(this, arguments);
//       if (location.search.includes("variant=")) {
//         handleVariantChange();
//       }
//     };
//   });
// });

// /* ================================
//    END: Essential Preorder app
//    ================================ */


/* ================================================================
   AUTO-SELECT AVAILABLE VARIANT ON OPTION CHANGE (designdeck)
   ----------------------------------------------------------------
   Problem: Bei Produkten, deren Optionen sich NICHT die gleichen
   Werte teilen (z. B. Hausbett-Himmel: Typ A und Typ B haben fast
   keine gemeinsame "Für"-Größe), bleibt beim Wechsel einer Option
   eine ungültige Kombination stehen -> "nicht verfügbar".
   Der Essence-Picker macht nur exakten Match und springt nicht auf
   eine gültige Variante.

   Fix: Capture-Phase change-Listener (läuft VOR dem Essence-Handler).
   Findet keine verfügbare Variante zur aktuellen Auswahl, überschreibt
   er die data-variant-id des geänderten Inputs mit der ersten
   verfügbaren Variante, die den gerade gewählten Wert (und nach
   Möglichkeit die Farbe) behält. Essence wechselt dann dorthin.

   Für normale Produkte (alle Kombis existieren) -> exakter Treffer,
   No-Op. Cross-Product-Combined-Listings werden übersprungen.
   ================================================================ */
(function () {
  function samePath(a, b) {
    try {
      return new URL(a, location.origin).pathname === new URL(b, location.origin).pathname;
    } catch (e) { return false; }
  }

  // Produkt-spezifische Wunsch-Größe je Typ (per Produkt-Handle). Erweiterbar.
  var PREFERRED_FUER_BY_TYP = {
    'lilimaus-hausbett-himmel': {
      'A - 1 Stoff': 'Hausbett 90x200cm & 120x200cm',
      'B - 2 Stoffe': 'Hausbett 120x200cm'
    },
    'betthimmel-hausbett-mit-gold': {
      'A - 1 Stoff': 'Hausbett 90x200cm & 120x200cm',
      'B - 2 Stoffe': 'Hausbett 120x200cm'
    }
  };
  // Standard-Typ beim Produktaufruf (Default-Variante). Erweiterbar.
  var DEFAULT_TYP = {
    'lilimaus-hausbett-himmel': 'B - 2 Stoffe',
    'betthimmel-hausbett-mit-gold': 'B - 2 Stoffe'
  };

  // Größen der jeweils ANDEREN Variante ausblenden (nicht klickbar):
  // pro Produkt-Handle die Optionsposition von "Typ" und "Größe/Für".
  var HIDE_RULES = {
    'lilimaus-hausbett-himmel': { typIdx: 1, sizeIdx: 2 },
    'betthimmel-hausbett-mit-gold': { typIdx: 1, sizeIdx: 2 }
  };

  // Liefert die Wunsch-Für-Größe für den aktuell gewählten Typ (oder null).
  function preferredFuerFor(handle, selected) {
    var m = PREFERRED_FUER_BY_TYP[handle];
    if (!m) return null;
    for (var i = 0; i < selected.length; i++) { if (m[selected[i]]) return m[selected[i]]; }
    return null;
  }

  // Aktuell gewählter Wert einer Optionsgruppe (Radio/Swatch ODER Dropdown).
  // Dropdown-Hidden-Input heißt je nach Theme-Version data-list-value ODER nur
  // input[type=hidden][name^="options"] -> beide abdecken.
  function readGroupValue(g) {
    var r = g.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    var li = g.querySelector('[data-list-value]')
          || g.querySelector('input[type="hidden"][name^="options"]')
          || g.querySelector('input[type="hidden"]');
    return li ? li.value : null;
  }

  document.addEventListener('change', function (e) {
    try {
      var target = e.target;
      if (!target || !target.closest) return;
      var picker = target.closest('variant-picker');
      if (!picker) return;
      if (!target.dataset || typeof target.dataset.variantId === 'undefined') return;

      // Cross-Product (echtes Combined Listing über mehrere Produkte) -> nicht eingreifen
      if (target.dataset.productUrl && picker.dataset.url &&
          !samePath(target.dataset.productUrl, picker.dataset.url)) return;

      var script = picker.querySelector('script[type="application/json"]');
      if (!script) return;
      var variants = JSON.parse(script.textContent);
      if (!Array.isArray(variants) || !variants.length) return;

      // Aktuelle Auswahl je Optionsgruppe (DOM-Reihenfolge = Optionsposition)
      var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
      var selected = groups.map(readGroupValue);
      var changedIdx = groups.findIndex(function (g) { return g.contains(target); });
      if (changedIdx < 0) return;

      var matchesAll = function (v) {
        var opts = v.options || [];
        for (var i = 0; i < selected.length; i++) {
          if (selected[i] != null && opts[i] !== selected[i]) return false;
        }
        return true;
      };

      // 1) Existiert die exakte Kombi überhaupt (egal ob lieferbar)?
      //    Ja -> NICHT eingreifen. Eine bloß ausverkaufte Variante soll als
      //    "ausverkauft" sichtbar bleiben (Essence zeigt das korrekt an).
      var exists = variants.find(function (v) { return matchesAll(v); });
      if (exists) return;

      // 2) Kombi existiert GAR NICHT (z. B. Typ A + reine B-Größe) -> auf eine
      //    passende Variante springen, die den gewählten Wert (und möglichst die
      //    Farbe = Position 0) behält; bevorzugt lieferbar, sonst erste existierende.
      var changedVal = selected[changedIdx];
      var pool = variants.filter(function (v) {
        return (v.options || [])[changedIdx] === changedVal;
      });
      if (changedIdx !== 0 && selected[0] != null) {
        var withColor = pool.filter(function (v) { return (v.options || [])[0] === selected[0]; });
        if (withColor.length) pool = withColor;
      }
      if (pool.length) {
        var prefFuer = preferredFuerFor(picker.dataset.productHandle, selected);
        var pick = (prefFuer && pool.find(function (v) {
          return v.available && (v.options || []).indexOf(prefFuer) !== -1;
        })) || pool.find(function (v) { return v.available; }) || pool[0];
        target.dataset.variantId = String(pick.id);
      }
    } catch (err) {
      /* fail-open: im Zweifel Essence unverändert lassen */
    }
  }, true); // capture: vor dem Essence-Handler


  /* ----------------------------------------------------------------
     DEFAULT-VARIANTE BEIM PRODUKTAUFRUF
     Wählt beim Laden die Wunsch-Variante (wenn verfügbar). Aktuell:
     Hausbett -> Typ B + 135x320. Farbe bleibt nach Möglichkeit die vom
     Theme gewählte (minimaler Wechsel). Später erweiterbar um eine
     umsatz-rangierte Liste je Produkt (Metafeld).
     ---------------------------------------------------------------- */
  function computeDefault(handle, variants, currentColor) {
    // 1) FESTE Produkt-Regel (z. B. Hausbett: Typ B + 135x320) hat Vorrang.
    var defTyp = DEFAULT_TYP[handle];
    var m = PREFERRED_FUER_BY_TYP[handle];
    if (defTyp && m && m[defTyp]) {
      var fuer = m[defTyp];
      var match = function (c, mustAvail) {
        return variants.find(function (v) {
          return (!c || v.options[0] === c)
            && (v.options || []).indexOf(defTyp) !== -1
            && (v.options || []).indexOf(fuer) !== -1
            && (!mustAvail || v.available);
        });
      };
      var hard = (currentColor && match(currentColor, true))
              || match(null, true)
              || (currentColor && match(currentColor, false));
      if (hard) return hard;
    }
    // 2) GENERELLE Umsatz-Regel: nach Shopify-Umsatz rangierte Bestseller-Liste
    //    (Metafeld custom.bestseller_variant_ids, vom Theme als JSON ausgegeben).
    //    Erste VERFÜGBARE Variante aus der Rangliste gewinnt. Vorbestell-Varianten
    //    (serverseitige ID-Liste am <variant-picker>) zählen wie ausverkauft.
    var el = document.querySelector('[data-bestseller-variants]');
    if (el) {
      try {
        var vp = document.querySelector('variant-picker');
        var preorderIds = ((vp && vp.dataset.preorderVariants) || '').split(',').filter(Boolean);
        var ids = JSON.parse(el.textContent || '[]');
        var excl = el.getAttribute('data-ab-preis-ohne') || '';
        var usable = function (v) {
          return v.available && preorderIds.indexOf(String(v.id)) === -1
            && !(excl && String(v.title || '').indexOf(excl) !== -1);
        };
        for (var i = 0; i < ids.length; i++) {
          var hit = variants.find(function (v) {
            return String(v.id) === String(ids[i]) && v.available
              && preorderIds.indexOf(String(v.id)) === -1;
          });
          if (hit) {
            // 2026-10-08: Farbe vom Bestseller, guenstigste Variante dieser Farbe
            // (gleich wie main-product.liquid; Startpreis = "Ab"-Preis der Karte).
            var best = usable(hit) ? hit : null;
            variants.forEach(function (v) {
              if ((v.options || [])[0] !== (hit.options || [])[0] || !usable(v)) return;
              if (!best || v.price < best.price) best = v;
            });
            return best || hit;
          }
        }
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  function applyDefaultVariant() {
    try {
      if (location.pathname.indexOf('/products/') === -1) return;
      if (new URL(location.href).searchParams.get('variant')) return; // expliziter Wunsch zählt
      var picker = document.querySelector('variant-picker');
      if (!picker || !picker.dataset.productHandle) return;
      var script = picker.querySelector('script[type="application/json"]');
      if (!script) return;
      var variants = JSON.parse(script.textContent);
      var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
      var sel = groups.map(readGroupValue);
      var target = computeDefault(picker.dataset.productHandle, variants, sel[0]);
      if (!target) return;
      if ((target.options || []).every(function (o, i) { return o === sel[i]; })) return; // schon gewählt
      var input = groups[0].querySelector('input[type="radio"]:checked')
        || groups[0].querySelector('[data-list-value]')
        || groups[0].querySelector('input[type="radio"]');
      if (!input) return;
      input.dataset.variantId = String(target.id);       // Essence switchVariant nutzt diese id
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { /* fail-open */ }
  }

  /* ----------------------------------------------------------------
     GRÖßEN DER ANDEREN VARIANTE AUSBLENDEN
     Blendet im Größen-Selektor die Werte aus, die es für den aktuell
     gewählten Typ GAR NICHT gibt (die der anderen Variante). Ausverkaufte,
     aber existierende Größen bleiben sichtbar (als "ausverkauft").
     Läuft beim Laden und nach jedem Varianten-Wechsel (Picker re-rendert).
     ---------------------------------------------------------------- */
  function hideIncompatibleSizes() {
    try {
      var picker = document.querySelector('variant-picker');
      if (!picker) return;
      var rule = HIDE_RULES[picker.dataset.productHandle];
      if (!rule) return;
      var script = picker.querySelector('script[type="application/json"]');
      if (!script) return;
      var variants = JSON.parse(script.textContent);
      var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
      var typVal = readGroupValue(groups[rule.typIdx]);
      var sizeGroup = groups[rule.sizeIdx];
      if (!sizeGroup || typVal == null) return;
      Array.prototype.forEach.call(sizeGroup.querySelectorAll('[data-option-value-id]'), function (el) {
        // Das versteckte Wert-Input des Dropdowns trägt auch data-option-value-id,
        // ist aber KEIN auswählbares Item -> überspringen.
        if (el.tagName === 'INPUT' && el.type === 'hidden') return;
        var val = el.tagName === 'INPUT' ? el.value : (el.dataset.value || el.textContent.trim());
        var exists = variants.some(function (v) {
          var o = v.options || [];
          return o[rule.typIdx] === typVal && o[rule.sizeIdx] === val;
        });
        var box = el.tagName === 'INPUT'
          ? (el.closest('label') || el.closest('.variant-radio') || el.parentElement || el)
          : el;
        box.style.display = exists ? '' : 'none';
      });
    } catch (e) { /* fail-open */ }
  }

  function init() {
    applyDefaultVariant();
    hideIncompatibleSizes();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Nach jedem Varianten-Wechsel re-rendert Essence den Picker -> erneut ausblenden
  document.addEventListener('variant:change', hideIncompatibleSizes);
})();


/* ================================================================
   PDP Task 4b (Marc, 2026-06-24): SCROLL ZUR GALERIE BEI ATTRIBUT-WECHSEL
   ----------------------------------------------------------------
   Wechselt der Kunde ein "echtes" Attribut (Typ, Stil, Form, Variante,
   Himmelstange, Motiv ...), wird auf Mobile so weit nach oben gescrollt,
   dass die komplette Galerie sichtbar ist -> Unterschied sofort erkennbar.
   NICHT bei reiner Farb- oder Größenauswahl (da bleibt die Sicht ruhig).
   Header-Freiraum kommt aus .product-media { scroll-margin-top } (custom.css).
   ================================================================ */
(function () {
  var COLOR_NAMES = ['farbe', 'color', 'colour'];
  var SIZE_NAMES = ['größe', 'grösse', 'groesse', 'size', 'für', 'fuer',
                    'länge', 'laenge', 'maße', 'masse', 'maß', 'menge', 'length'];
  var MOBILE_MAX = 991;

  function norm(s) { return (s || '').toString().trim().toLowerCase(); }

  // "Echtes" Attribut = nicht Farbe und nicht Größe.
  function isVisualAttribute(name) {
    var n = norm(name);
    if (!n) return false;
    if (COLOR_NAMES.indexOf(n) !== -1) return false;
    if (SIZE_NAMES.indexOf(n) !== -1) return false;
    return true;
  }

  function optionNameFromGroup(group) {
    if (!group) return '';
    if (group.dataset && group.dataset.optionName) return group.dataset.optionName;
    var lg = group.querySelector('legend, .label-product-info');
    if (lg) return lg.textContent.replace(':', '');
    if (group.getAttribute && group.getAttribute('list-title')) return group.getAttribute('list-title');
    return '';
  }

  function scrollGalleryIntoView() {
    if (window.innerWidth > MOBILE_MAX) return; // nur Mobile
    var media = document.querySelector('.product-media');
    if (!media) return;
    // Header-Höhe live messen (die CSS-Variablen sind nicht immer gesetzt),
    // damit das GANZE Bild unter dem (ggf. Sticky-)Header sichtbar ist.
    var header = document.querySelector('.header') || document.querySelector('sticky-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var y = media.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  document.addEventListener('change', function (e) {
    try {
      var target = e.target;
      if (!target || !target.closest) return;
      if (!target.closest('variant-picker')) return;
      var group = target.closest('[data-option-group]');
      if (!isVisualAttribute(optionNameFromGroup(group))) return;
      // Galerie lädt per AJAX neu (product-media: variant:change) -> kurz warten, dann scrollen.
      setTimeout(scrollGalleryIntoView, 400);
    } catch (err) { /* fail-open */ }
  }, false);
})();


/* ================================================================
   CONTEXTUAL SWATCH AVAILABILITY (designdeck)
   ----------------------------------------------------------------
   Problem: Shopifys `option_value.available` ist GLOBAL pro Farbe –
   solange eine Farbe in IRGENDEINER Typ-/Größen-Kombination lieferbar
   ist, wird die Farbkachel NICHT durchgestrichen. Beim Hausbett hat
   jede Farbe noch mindestens eine lieferbare Größe -> nie ein Strich,
   obwohl die konkret gewählte Kombination ausverkauft sein kann.

   Fix: Nach jeder Optionsänderung (Typ/Größe) die Farben KONTEXT-
   ABHÄNGIG neu bewerten: Gibt es zur aktuell gewählten Kombination
   (übrige Optionen fix) eine LIEFERBARE Variante dieser Farbe? Wenn
   nein -> Klasse `option-unavailable` setzen (CSS zeichnet die
   Diagonale). Wenn ja -> Klasse entfernen.

   Datenquelle ist dasselbe Varianten-JSON im <variant-picker>, das der
   Auto-Select-Block oben nutzt (v.options[] in Optionsreihenfolge,
   v.available = kauffähig). Nur bei Pickern OHNE
   `.hide-sold-out-variants` aktiv (sonst würde die Kachel versteckt
   statt gestrichen). Fail-open: im Zweifel nichts ändern.

   Vorbestellung (Ansage Marc 31.07.2026): Varianten mit
   inventory_policy=CONTINUE und Bestand <= 0 sind zwar `available`
   (kaufbar als Vorbestellung), sollen im Picker aber wie ausverkauft
   gestrichen werden. Das Varianten-JSON hier enthält Policy/Bestand
   NICHT - die IDs kommen deshalb serverseitig aus dem Attribut
   `data-preorder-variants` am <variant-picker> (Liquid sieht beides).
   Eigene Klasse `option-preorder` (gleiche Optik wie
   `option-unavailable`), damit hide-sold-out-Logik sie nie versteckt.
   ================================================================ */
(function () {
  function readGroupValue(g) {
    var r = g.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    var li = g.querySelector('[data-list-value]')
          || g.querySelector('input[type="hidden"][name^="options"]')
          || g.querySelector('input[type="hidden"]');
    return li ? li.value : null;
  }

  function recompute(picker) {
    try {
      // Versteckt-statt-streichen aktiv? -> nicht eingreifen (sonst würden
      // Farben beim Größenwechsel ein-/ausgeblendet statt gestrichen).
      if (picker.classList.contains('hide-sold-out-variants')) return;

      var script = picker.querySelector('script[type="application/json"]');
      if (!script) return;
      var variants = JSON.parse(script.textContent);
      if (!Array.isArray(variants) || !variants.length) return;

      var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
      if (!groups.length) return;

      // Farbgruppe = die mit Farbkacheln (color-swatch-selector).
      var colorIdx = -1;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].querySelector('.color-swatch-selector')) { colorIdx = i; break; }
      }
      if (colorIdx < 0) return; // Farbe nicht als Swatch gerendert -> nichts zu tun

      var preorderIds = {};
      String(picker.getAttribute('data-preorder-variants') || '')
        .split(',')
        .forEach(function (id) { if (id) preorderIds[id] = true; });

      var selected = groups.map(readGroupValue);
      var swatches = groups[colorIdx].querySelectorAll('.color-swatch-selector input[type="radio"]');
      Array.prototype.forEach.call(swatches, function (inp) {
        var color = inp.value;
        var anyMatch = false;    // irgendeine kaufbare Variante (inkl. Vorbestellung)
        var anyInStock = false;  // sofort lieferbar (kaufbar und KEINE Vorbestellung)
        variants.forEach(function (v) {
          var o = v.options || [];
          if (o[colorIdx] !== color) return;
          for (var j = 0; j < groups.length; j++) {
            if (j === colorIdx) continue;
            if (selected[j] != null && o[j] !== selected[j]) return;
          }
          if (v.available === true) {
            anyMatch = true;
            if (!preorderIds[String(v.id)]) anyInStock = true;
          }
        });
        inp.classList.toggle('option-unavailable', !anyMatch);
        inp.classList.toggle('option-preorder', anyMatch && !anyInStock);
      });
    } catch (e) { /* fail-open */ }
  }

  function recomputeAll() {
    var pickers = document.querySelectorAll('variant-picker');
    Array.prototype.forEach.call(pickers, recompute);
  }

  // Nach jeder Optionsänderung neu bewerten. setTimeout(…, 0), damit der
  // Auto-Select/Essence-Handler die neue Auswahl zuerst setzen kann.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-picker')) {
      setTimeout(recomputeAll, 0);
    }
  }, false);

  // Essence rendert den Picker bei Variantenwechsel per AJAX neu und
  // überschreibt dabei unsere Klassen -> nach jedem Re-Render erneut anwenden.
  // Nur childList/subtree beobachten (NICHT attributes), damit unsere eigenen
  // classList-Toggles keine Endlosschleife auslösen.
  var mo = new MutationObserver(function () { setTimeout(recomputeAll, 0); });
  function observePickers() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-picker'), function (p) {
      if (!p.__ctxSwatchObserved) {
        p.__ctxSwatchObserved = true;
        mo.observe(p, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState !== 'loading') { recomputeAll(); observePickers(); }
  else document.addEventListener('DOMContentLoaded', function () { recomputeAll(); observePickers(); });
})();

/* ============================================================
   WALLET-BUTTON-REIHENFOLGE (Warenkorb-Seite)
   Shopify rendert die Express-Buttons (Shop Pay, PayPal, G Pay)
   in fester Slot-Reihenfolge innerhalb eines geschlossenen
   Shadow DOM — CSS `order` und DOM-Umsortierung greifen nicht.
   Die Light-DOM-Kinder tragen benannte Slots (button-ShopPay,
   button-PayPal, ...); wir tauschen die Slot-Zuweisungen, sodass
   PayPal die oberste Position bekommt und Shop Pay die unterste.
   ============================================================ */
(function () {
  var pending = false;

  // Kleinere Zahl = weiter oben. Shop Pay bewusst ganz ans Ende.
  function priority(el) {
    var t = el.tagName.toLowerCase();
    if (t.indexOf('paypal') !== -1) return 1;
    if (t.indexOf('apple') !== -1) return 2;
    if (t.indexOf('google') !== -1) return 3;
    if (t.indexOf('shop-pay') !== -1) return 9;
    return 5;
  }

  function resort(host) {
    var kids = Array.prototype.filter.call(host.children, function (c) {
      return c.hasAttribute('slot');
    });
    if (kids.length < 2) return;

    // Aktuelle visuelle Position jedes Slots messen (top, dann left —
    // deckt vertikales und horizontales Button-Layout ab).
    var slots = [];
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.height === 0) return; // noch Skeleton/nicht gerendert -> später erneut
      slots.push({ name: kids[i].getAttribute('slot'), top: r.top, left: r.left });
    }
    slots.sort(function (a, b) { return (a.top - b.top) || (a.left - b.left); });

    var sorted = kids.slice().sort(function (a, b) { return priority(a) - priority(b); });
    sorted.forEach(function (el, idx) {
      if (el.getAttribute('slot') !== slots[idx].name) {
        el.setAttribute('slot', slots[idx].name);
      }
    });
  }

  function scan() {
    pending = false;
    Array.prototype.forEach.call(
      document.querySelectorAll('shopify-accelerated-checkout-cart'),
      resort
    );
  }

  // Buttons erscheinen asynchron (Web Components + Skeleton) und werden
  // bei Section-Re-Renders neu eingesetzt -> childList beobachten.
  // Attribut-Änderungen (unsere Slot-Tauschs) lösen den Observer NICHT aus.
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(scan, 50);
  });

  function init() {
    scan();
    mo.observe(document.body, { childList: true, subtree: true });
    // Fallback: nach dem Laden erneut prüfen (Skeleton -> echte Buttons)
    setTimeout(scan, 1000);
    setTimeout(scan, 3000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ============================================================
   PDP: IMMER PAYPAL ALS EXPRESS-BUTTON (Ansage Linus 01.10.)
   Shopify waehlt auf der PDP genau EIN Wallet je Besucher (meist
   Shop Pay) und schreibt es ins Attribut "recommended". Die
   PayPal-Konfiguration steht im Warenkorb-Baustein, den
   product-page-buy-buttons.liquid als <template> mitliefert.
   Wir setzen sie als "recommended" ein und ersetzen das Element,
   damit es neu rendert. Fehlt die Konfiguration, blendet
   custom.css den Nicht-PayPal-Button aus (kein Shop Pay).
   ============================================================ */
(function () {
  var pending = false;
  var swaps = 0; // Notbremse, falls Shopify recommended je zurueckschreibt

  function paypalConfig() {
    var tpl = document.querySelector('template[data-lm-wallet-configs]');
    var el = tpl && tpl.content.querySelector('shopify-accelerated-checkout-cart');
    if (!el) return null;
    try {
      var cfgs = JSON.parse(el.getAttribute('wallet-configs') || '[]');
      for (var i = 0; i < cfgs.length; i++) {
        if (cfgs[i].name === 'paypal') return JSON.stringify(cfgs[i]);
      }
    } catch (e) {}
    return null;
  }

  function swap() {
    pending = false;
    var cfg = paypalConfig();
    if (!cfg) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.shopify-payment-button shopify-accelerated-checkout'),
      function (el) {
        var rec;
        // recommended kann "null" sein (Shopify prueft das selbst) -> || {}
        try { rec = JSON.parse(el.getAttribute('recommended') || '{}') || {}; } catch (e) { rec = {}; }
        if (rec.name === 'paypal' || swaps >= 20) return;
        swaps++;
        var neu = document.createElement('shopify-accelerated-checkout');
        el.getAttributeNames().forEach(function (a) { neu.setAttribute(a, el.getAttribute(a)); });
        neu.setAttribute('recommended', cfg);
        el.replaceWith(neu);
      }
    );
  }

  // Variantenwechsel rendert die Buy-Buttons neu -> childList beobachten.
  // Unser eigener Tausch loest den Observer aus, endet aber beim
  // zweiten Durchlauf (recommended ist dann paypal).
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(safeSwap, 50);
  });

  // Fehler hier duerfen den Rest von custom.js (Modul) nie abreissen.
  function safeSwap() {
    try { swap(); } catch (e) { pending = false; }
  }

  function init() {
    safeSwap();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ================================
   STICKY ADD-TO-CART AB SEITENAUFRUF (NUR MOBIL)
   Notes Linus 2026-08: Der Kauf-Button soll auf der PDP immer sichtbar sein.
   Theme-Logik (main.mjs, <sticky-add-to-cart>) zeigt die Leiste erst, wenn der
   echte Button NACH OBEN aus dem Viewport gescrollt ist (y < 0) - mobil ist er
   beim Laden aber UNTERHALB des Folds, also war anfangs nichts sichtbar.
   Hier: Theme-Observer stilllegen und eigene Logik ohne y<0-Bedingung -
   Leiste zeigen, sobald der echte Button nicht im Viewport ist (oben ODER unten).
   Desktop (>=992px) behaelt die Theme-Logik unveraendert.
   Zusatz: Label + disabled des echten Buttons spiegeln (Ausverkauft-Zustand).
   ================================ */
(function () {
  if (window.matchMedia('(min-width: 992px)').matches) return;

  function init() {
    var el = document.querySelector('sticky-add-to-cart');
    if (!el) return;

    customElements.whenDefined('sticky-add-to-cart').then(function () {
        // Kein requestAnimationFrame: feuert in Hintergrund-Tabs nicht.
        // whenDefined loest nach dem Upgrade (inkl. connectedCallback) auf.
        // Theme-Observer abklemmen (connectedCallback hat ihn bereits gestartet)
        if (el.observer) el.observer.disconnect();

        var stickyBtn = el.querySelector('button.button');

        function realBtn() {
          var section = el.closest('.shopify-section');
          return section ? section.querySelector('.button-add-to-cart') : null;
        }

        function mirror() {
          var btn = realBtn();
          if (!btn || !stickyBtn) return;
          stickyBtn.disabled = btn.disabled;
          var label = (btn.textContent || '').trim();
          var span = stickyBtn.querySelector('span');
          if (label && span && span.textContent.trim() !== label) {
            span.textContent = label;
          }
        }

        var btn = realBtn();
        var footer = document.querySelector('.footer');
        if (!btn) return;

        var btnVisible = false;
        var footerVisible = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.target === btn) btnVisible = en.isIntersecting;
            else if (en.target === footer) footerVisible = en.isIntersecting;
          });
          // setVisible der Theme-Klasse wiederverwenden (show/hide + Debounce)
          el.setVisible(!btnVisible && !footerVisible);
        }, { threshold: 0.2 });
        io.observe(btn);
        if (footer) io.observe(footer);

        mirror();
        document.addEventListener('variant:change', function () {
          // Button wird beim Varianten-Wechsel per Section-Re-Render ersetzt;
          // updateDOM des Themes ist rAF-gebatcht -> kurz warten (kein rAF, s. o.)
          setTimeout(mirror, 50);
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   FARBFILTER: EINZELFARBEN (Ansage Linus 08.09.2026)

   Der Farbfilter zeigt nur noch Einzelfarben. Eine Kachel steht
   fuer alle Optionswerte, in denen diese Farbe vorkommt — "Blau"
   deckt "Blau", "Blau & Creme", "Blau & Eukalyptus" und
   "Blau & Hellbeige" ab. Die echten Filter-Checkboxen liegen
   versteckt unter der Kachel (siehe snippets/filter-values-color.liquid);
   hier werden sie mitgeschaltet.

   Capture-Phase am document ist Absicht: <facet-filters-form>
   haengt seinen change-Listener am Formular (Bubbling). In der
   Capture-Phase sind wir vorher dran, die Mitglieder stehen also
   schon richtig, wenn daraus die FormData gebaut wird. Das
   change-Event der Kachel selbst blubbert weiter zum Formular und
   loest die Filterung aus — kein eigenes dispatchEvent noetig.

   Die Kachel-Checkbox hat bewusst KEIN name-Attribut, damit sie
   nicht selbst in der FormData landet.
   ============================================================ */
(function () {
  document.addEventListener(
    'change',
    function (e) {
      var toggle = e.target;
      if (!toggle || !toggle.hasAttribute || !toggle.hasAttribute('data-color-group-toggle')) return;

      var group = toggle.closest ? toggle.closest('[data-color-group]') : null;
      if (!group) return;

      // EINFACHAUSWAHL (Ansage Linus 21.09.2026): Eine neu gewaehlte Farbe
      // ERSETZT die vorher gewaehlte, statt sich zu ihr zu addieren. Erneuter
      // Klick auf die aktive Kachel hebt den Farbfilter wieder auf.
      //
      // Abgeraeumt wird wertweit ueber ALLE Gruppen des Formulars, nicht nur
      // ueber die eigene: Kombiwerte haengen in mehreren Gruppen gleichzeitig
      // ("Blau & Creme" ist Mitglied bei Blau UND bei Creme). Wer nur die
      // eigene Gruppe zuruecksetzt, laesst die Zwillinge in den Nachbargruppen
      // angehakt — dann bleibt nach dem Abwaehlen ein Rumpffilter stehen und
      // derselbe Wert landet doppelt in der FormData.
      //
      // Scope ist bewusst das eigene <form>: Desktop-Sidebar und mobiler
      // Drawer sind zwei getrennte Formulare und duerfen sich nicht
      // gegenseitig zuruecksetzen.
      var scope = (toggle.closest && toggle.closest('form')) || document;

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-color-group-toggle]'),
        function (other) {
          if (other !== toggle) other.checked = false;
        }
      );
      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-color-group-member]'),
        function (member) {
          member.checked = false;
        }
      );

      if (toggle.checked) {
        Array.prototype.forEach.call(
          group.querySelectorAll('[data-color-group-member]'),
          function (member) {
            member.checked = true;
          }
        );
      }
    },
    true
  );
})();
